// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"dd113533","193":"ca619ee2","467":"5a4d8f4a","604":"3b34dec5","610":"45bccbe4","787":"bca6f9fb"}[chunkId] + ".chunk.js";
};